import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import EmptyContent from 'src/components/empty-content';

interface CustomEmptyTableStateProps {
  description?: string;
}

export default function CustomEmptyTableState({ description }: CustomEmptyTableStateProps) {
  return (
    <TableRow>
      <TableCell colSpan={12}>
        <EmptyContent
          filled
          description={
            description || 'No summaries to display. Start by uploading your first recording.'
          }
          sx={{ py: 10 }}
        />
      </TableCell>
    </TableRow>
  );
}
